import type {
  ModelDuplicateFormProps,
  ModelDuplicateFormDefaultValues,
} from "./model-duplicate-form.type";

import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import SidePanelFormFooter from "@/modules/side-panel-form-footer";

const ModelDuplicateForm = <Values extends ModelDuplicateFormDefaultValues>({
  form,
  formId,
  initialValues,
  customFields,
  submitText,
  onFormSubmit,
  loading,
  validation,
  validationErrors,
}: ModelDuplicateFormProps<Values>) => {
  const { t } = useTranslation();

  return (
    <Form
      form={form}
      id={formId}
      initialValues={initialValues}
      onFinish={onFormSubmit}
      layout="vertical"
      role="form"
    >
      <Form.Item
        name="name"
        label={t("global:name")}
        rules={[{ required: true }]}
        {...validation("name")}
      >
        <Input placeholder={t("global:name")} />
      </Form.Item>
      {customFields}
      {validationErrors().others && <Form.Item {...validation("others")} />}
      <SidePanelFormFooter
        submitText={submitText ?? t("global:duplicate")}
        submitProps={{ loading, form: formId }}
        position="follow-content"
      />
    </Form>
  );
};

export default ModelDuplicateForm;
